import API from '../../services/api';

const api = new API();

const URL_FRAUD_RULES = '/api/fraud/rules';
const URL_FRAUD_RULES_META = '/api/fraud/rules/meta';

const unwrapLegacyResponse = response => {
    if (!response || response.status !== 0) {
        return Promise.reject(response && response.value);
    }
    return response.value;
};

export function fetchRulesMeta() {
    return api
        .getJson(URL_FRAUD_RULES_META, {
            method: 'GET',
            credentials: 'include',
            cache: false,
        })
        .then(unwrapLegacyResponse);
}

export function fetchRules() {
    return api
        .getJson(URL_FRAUD_RULES, {
            method: 'GET',
            credentials: 'include',
            cache: false,
        })
        .then(unwrapLegacyResponse);
}

export function saveRule(payload) {
    return api
        .getJson(URL_FRAUD_RULES, {
            method: 'POST',
            credentials: 'include',
            body: payload,
        })
        .then(unwrapLegacyResponse);
}

export function deleteRule(id) {
    return api
        .getJson(URL_FRAUD_RULES, {
            method: 'DELETE',
            credentials: 'include',
            body: { id },
        })
        .then(unwrapLegacyResponse);
}
